import { render, staticRenderFns } from "./NotificationDialog.vue?vue&type=template&id=fca5b208"
import script from "./NotificationDialog.vue?vue&type=script&lang=ts"
export * from "./NotificationDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports